import { GroupHeader } from '@/components/groups/GroupHeader'

export default function BrowsePage() {
  return (
    <div className="cg-screen">
      <GroupHeader sublabel="Browse Steam" />
      <div className="cg-empty">Coming soon — search the Steam catalog and add to wishlist</div>
    </div>
  )
}
